enum DomainEnums {
    PRODUCTION_DOMAIN = 'new.keyapp.top'
}
export { DomainEnums };
